var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('transition',{attrs:{"name":"route","mode":"out-in"}},[_c(slotProps.Component,{tag:"component"})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }